import Button from "./Button.jsx";
import {useRef} from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCopy} from "@fortawesome/free-solid-svg-icons";
import {useTranslation} from "react-i18next";
import toast from "react-hot-toast";

export default function TextareaWithClipboard({value, showButton, textareaClasses = ''}) {
    let {t} = useTranslation();
    const textareaRef = useRef(null);

    const copyTextareaContents = () => {
        const textarea = textareaRef.current;
        textarea.select();
        navigator.clipboard.writeText(textarea.value).then(() => {
            toast.success(t('copy-to-clipboard-success'));
        }).catch(() => {
            toast.error(t('copy-to-clipboard-failed'));
        });
    };

    let textAreaClassName = (showButton ? ' w-11/12 ' : ' w-full ') + textareaClasses;

    return <div className={'flex'}>
        <textarea
            className={'form-input rounded-r-none' + textAreaClassName}
            ref={textareaRef}
            value={value}
            readOnly={true}
        />
        {showButton &&
            <Button
                className={'button button-dark-outline w-1/12'}
                title={t('copy-to-clipboard')}
                onClick={copyTextareaContents}
            >
                <FontAwesomeIcon icon={faCopy}/>
            </Button>
        }
    </div>;
}